import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface OfflineBannerState {
  open: boolean;
  online: boolean;
}

const initialState: OfflineBannerState = {
  open: false,
  online: navigator.onLine,
};

export const offlineBannerSlice = createSlice({
  name: "OfflineBanner",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setOnline: (state, action: PayloadAction<boolean>) => {
      state.online = action.payload;
    },
  },
});

export const { setOpen, setOnline } = offlineBannerSlice.actions;

export default offlineBannerSlice.reducer;
